export default {
  // Hero 區塊
  hero: {
    title: '功能特色',
    subtitle: '探索我們為您和您的寵物提供的所有強大功能'
  },
  
  // 狀態標籤
  status: {
    available: '已上線',
    beta: '測試版'
  },
  
  // 核心功能區塊
  core: {
    badge: '核心功能',
    title: '必備工具',
    description: '這些是讓寵物照護變得簡單有效的基礎功能',
    
    petProfiles: {
      title: '寵物檔案',
      description: '為每隻寵物建立完整的數位檔案，包含所有重要資訊',
      feature1: '完整資訊記錄',
      feature2: '照片上傳',
      feature3: '醫療記錄',
      feature4: '行為筆記'
    },
    
    secureSharing: {
      title: '安全分享',
      description: '透過加密連結安全地分享寵物資訊給授權的人',
      feature1: '獨特分享連結',
      feature2: '唯讀權限',
      feature3: '無需登入',
      feature4: '隱私受保護'
    },
    
    schedule: {
      title: '時程管理',
      description: '設定和追蹤餵食、用藥和活動時間表',
      feature1: '餵食時間表',
      feature2: '用藥提醒',
      feature3: '運動追蹤',
      feature4: '獸醫預約'
    },
    
    healthTracking: {
      title: '健康追蹤',
      description: '監控寵物的健康指標和醫療歷史',
      feature1: '體重追蹤',
      feature2: '疫苗接種記錄',
      feature3: '過敏管理',
      feature4: '獸醫記錄'
    },
    
    mobileFriendly: {
      title: '行動裝置友善',
      description: '在任何裝置上都能完美運作的響應式設計',
      feature1: '響應式設計',
      feature2: '觸控優化',
      feature3: '跨平台',
      feature4: '離線資料快取'
    },
    
    multiLanguage: {
      title: '多語言支援',
      description: '支援繁體中文、英文和日文介面',
      feature1: '繁體中文支援',
      feature2: '英文支援',
      feature3: '日文支援',
      feature4: '即時語言切換'
    }
  },
  
  // 進階功能區塊
  advanced: {
    badge: '進階功能',
    title: '強大工具',
    description: '為進階用戶提供的專業功能',
    
    security: {
      title: '增強安全性',
      description: '採用業界標準加密技術保護您的寵物資料，確保只有授權用戶可以存取'
    },
    
    multiUser: {
      title: '多人存取',
      description: '允許多位家庭成員或照護者同時查看寵物資訊，共同參與照護'
    },
    
    editing: {
      title: '完整編輯功能',
      description: '隨時更新寵物資訊，包括照片、醫療記錄和時程表'
    },
    
    cloudSync: {
      title: '雲端同步',
      description: '自動同步到雲端，確保資料安全且可在任何裝置上存取'
    },
    
    location: {
      title: '位置追蹤',
      description: '記錄寵物的當前位置和獸醫診所資訊，方便緊急情況使用'
    },
    
    performance: {
      title: '效能優化',
      description: '快速載入和流暢的使用體驗，即使管理多隻寵物也不會卡頓'
    }
  },
  
  // 即將推出區塊
  upcoming: {
    badge: '即將推出',
    title: '即將推出的功能',
    description: '我們正在開發更多令人興奮的功能，敬請期待',
    
    notifications: {
      title: '智慧通知',
      description: '根據寵物的時程表接收智慧提醒，永不錯過重要事項'
    },
    
    backup: {
      title: '自動備份與還原',
      description: '自動備份您的寵物資料，並可隨時還原到先前的版本'
    },
    
    calendar: {
      title: '行事曆整合',
      description: '與您的行事曆應用程式同步，將寵物活動加入日常行程'
    },
    
    community: {
      title: '社群功能',
      description: '與其他寵物主人交流經驗，分享照護心得'
    },
    
    healthTrends: {
      title: '健康趨勢分析',
      description: '透過圖表和報告分析寵物的健康趨勢，及早發現問題'
    },
    
    vetIntegration: {
      title: '獸醫診所整合',
      description: '直接與獸醫診所系統連接，自動同步醫療記錄'
    }
  },
  
  // CTA 區塊
  cta: {
    title: '準備探索所有功能了嗎？',
    subtitle: '立即開始使用這些強大的功能，讓寵物照護更輕鬆'
  }
};